import React from "react";
import { Row, Col, Space } from "antd";
import { Modal } from "../../../core";
import { Input, Typography, Button, Loading } from "../../../core";
import styled from "styled-components";
import { Form } from "antd";
import { MixStyle } from "../../../styles";
import { updateBuyer } from "../../../helper/utils/api/buyer";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const EditBuyerModal = ({
  editBuyerModal,
  closeModal,
  getAllBuyersWithCompanyId,
  dataToEdit,
}) => {
  const [form] = Form.useForm();

  const [formInitialValue, setFormInitialValue] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    setFormInitialValue(dataToEdit);
  }, [dataToEdit]);

  const onFinish = async (fieldsValue) => {
    setIsLoading(true);
    try {
      const buyerIdToEdit = formInitialValue._id;
      const companyId = localStorage.getItem("companyId");
      const response = await updateBuyer(buyerIdToEdit, {
        ...fieldsValue,
        companyId,
      });
      Notify_Utils.openNotificationWithIcon(
        "success",
        response.data.message || "Buyer updated successfully"
      );
      closeModalHandler();
      getAllBuyersWithCompanyId();
    } catch (error) {
      const message =
        error?.response?.data?.message || "Error while updating buyer";
      Notify_Utils.openNotificationWithIcon("error", message);
    }
    setIsLoading(false);
  };
  const onFinishFailed = (errorInfo) => {};

  const closeModalHandler = () => {
    closeModal("editBuyerModal");
  };

  return (
    <Modal
      closable={true}
      visible={editBuyerModal}
      okText="Add"
      maxwidth="800px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Edit Buyer"
    >
      {isLoading ? <Loading /> : null}

      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={formInitialValue}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Name"
              name="buyerName"
              rules={[
                {
                  required: true,
                  message: "Please input Name!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Buyer Company Name"
              name="companyName"
              rules={[
                {
                  required: true,
                  message: "Please Buyer Company Name!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Phone Number"
              name="phoneNumber"
              rules={[
                {
                  required: true,
                  message: "Please input Phone Number!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="NTN"
              name="NTN"
              rules={[
                {
                  required: true,
                  message: "Please input NTN!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="STRN"
              name="STRN"
              rules={[
                {
                  required: true,
                  message: "Please input strn!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Address"
              name="companyAddress"
              rules={[
                {
                  required: true,
                  message: "Please input Address!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12}>
            <Form.List name="GodownAddress">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    <Typography
                      align="center"
                      weight="bold"
                      color="#233B67"
                      as="h3"
                    >
                      Godown Address
                    </Typography>
                    {fields.map((field, index) => (
                      <Space
                        key={field.key}
                        style={{
                          display: "flex",
                          marginBottom: 8,
                          justifyContent: "center",
                        }}
                        align="start"
                      >
                        {/* <Form.Item
                        
                         
                          required={true}
                          key={field.key}
                        > */}

                        <Form.Item
                          {...field}
                          // label={index === 0 ? "Godown Address" : ""}
                          validateTrigger={["onChange", "onBlur"]}
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: "Please Input Godown Address",
                            },
                          ]}
                          noStyle
                        >
                          <Input
                            placeholder="Godown Address"
                            style={{ width: "100%" }}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            style={{ margin: "0 8px" }}
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                        {/* </Form.Item> */}
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        width="150px"
                        margin="auto"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined /> Add More Godown
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.List name="departmentInfo">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    <Typography
                      align="center"
                      weight="bold"
                      color="#233B67"
                      as="h3"
                    >
                      Department Information
                    </Typography>
                    {fields.map((field, index) => (
                      <Space
                        key={field.key}
                        style={{
                          display: "flex",
                          marginBottom: 8,
                          justifyContent: "space-between",
                        }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "department_name"]}
                          fieldKey={[field.fieldKey, "department_name"]}
                          rules={[
                            {
                              required: false,
                              message: "Missing Department Name",
                            },
                          ]}
                        >
                          <Input placeholder="Department Name" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "person_name"]}
                          fieldKey={[field.fieldKey, "person_name"]}
                          rules={[
                            { required: false, message: "Missing Person Name" },
                          ]}
                        >
                          <Input placeholder="Person Name" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "phoneNumber"]}
                          fieldKey={[field.fieldKey, "phoneNumber"]}
                          rules={[
                            {
                              required: false,
                              message: "Missing Phone Number",
                            },
                          ]}
                        >
                          <Input placeholder="Phone Number" />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            className="dynamic-delete-button"
                            style={{ margin: "0 8px" }}
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                        {/* <MinusCircleOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        /> */}
                      </Space>
                    ))}

                    <Form.Item>
                      <Button
                        width="150px"
                        margin="auto"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined /> Add More Departments
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col md={16}>
            <Form.Item>
              {/* {state.length > 1 && ( */}
              <Row type="flex" justify="space-between">
                <Col md={12}>
                  <Button
                    width="187px"
                    bg="#404E67"
                    type="primary"
                    htmlType="submit"
                  >
                    <Typography
                      text="Update Buyer"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Col>
                <Col md={12}>
                  <Button
                    width="187px"
                    bg="#404E67"
                    type="primary"
                    onClick={closeModalHandler}
                  >
                    <Typography
                      text="Cancel"
                      as="h5"
                      noMargin
                      weight="bold"
                      align="center"
                      color="white"
                    />
                  </Button>
                </Col>
              </Row>
              {/* )} */}
            </Form.Item>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default EditBuyerModal;
